<template>
  <div class="container" />
</template>


<script>
import {
  mapActions,
  mapGetters
} from "vuex";



import browserSignature from 'browser-signature';


// eslint-disable-next-line no-unused-vars
const signature = browserSignature();

export default {
  components: {},

  setup() {

  },

  data() {
    return {
      nonce: this.$route.query.nonce ?? ''
    };
  },
  computed: {
    ...mapGetters(["isSSOLogin", "user"])
  },

  watch: {
    user: function () {

      if (this.user != 'undefined') {
        localStorage.removeItem('redirect_to')
        localStorage.setItem('user', JSON.stringify(this.user))
        localStorage.setItem('isSilentLogin', true)
        localStorage.setItem('is_from_mobile', Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0)
        let redirect_to = this.$route.query?.redirect_to ?? ''
        console.log("redirect_to === ", redirect_to);

        if (redirect_to == 'diagnosis_edit') {
          this.$router.push({
            path: `/edit-summary/${this.$route.query.booking_id}`,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } else if (redirect_to == 'protection_plans') {
          localStorage.setItem('isProtectionPlans', true)
          this.$router.push({
            path: '/protection-plan/nrg/bundle-list',
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } else if (redirect_to == 'diagnosis') {
          this.$router.push({
            path: `/select/unit/${this.$route.query.booking_id}`,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } else if (redirect_to.includes('checkout/invoice')) {
          this.$router.push({
            path: redirect_to,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } else if (redirect_to.includes('quote/edit/')) {
          this.$router.push({
            path: redirect_to,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } else {
          this.$router.push({
            path: redirect_to,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } 
      }

    },
  },

  mounted() {
    const loginFailed = this.$route.query.login_failed ?? 0
    localStorage.setItem('is_from_mobile', 1)

    if (!this.isSSOLogin && loginFailed == '0') {
      this.onSSOLogin()
    } else if (loginFailed == '1') {

    } else {
      if (this.user != 'undefined') {
        localStorage.setItem('user', JSON.stringify(this.user))
        localStorage.setItem('isSilentLogin', true)
        let redirect_to = this.$route.query?.redirect_to ?? ''

        if (redirect_to == 'diagnosis_edit') {
          this.$router.push({
            path: `/edit-summary/${this.$route.query.booking_id}`,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        }  else if (redirect_to == 'protection_plans') {
          localStorage.setItem('isProtectionPlans', true)

          this.$router.push({
            path: '/protection-plan/nrg/bundle-list',
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0,
            }
          });
        } else if (redirect_to == 'diagnosis') {
          this.$router.push({
            path: `/select/unit/${this.$route.query.booking_id}`,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } 
        else if (redirect_to.includes('checkout/invoice')) {
          this.$router.push({
            path: redirect_to,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } else {
          this.$router.push({
            path: redirect_to,
            query: {
              is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
            }
          });
        } 
      }
    }

  },

  methods: {
    ...mapActions(["setSSOLogin"]),
    onSSOLogin() {
      console.log("On SSO Login")
      this.setSSOLogin({
        nonce: this.nonce,
        from_device_id: this.$route.query.from_device_id,
        device_id: signature,
        device_type: "web",
        device_token: "{{$guid}}",
        timestamp: (new Date()).getTime()
      });
    },
  },
};
</script>
